import { ImplementCycleDetails } from "../add-observation-point/add-observation-point-modal";
import { GenericIdName } from "../setup-implement/setup-implement.model";
import {  Family, JobSite, Model } from "../entities/global/model";

export class DashboardPageConstants {
    // Title
    public PAGE_TITLE: string = '';

    // Sub-title
    public PAGE_SUBTITLE: string = '';
}

export class EquipmentDetails {
    public SerialNumber: string;
    public UnitNumber: string;
    public Model: string;
    public JobSite: string;
    public SMU: number;
    public LastInspection: string;
}

export class DashboardSearchFilter {
    public Customers: number[];
    public Jobsites: number[];
    public Equipment: number[];
    public Families: number[];
    public Makes: number[];
    public Models: number[];
    public Implements: number[];
    public NoImplemets:boolean;
    public ImplementTypes: number[];
    public ComponentTypes:number[];

}

export class DashboardImplementCondition {
    public ImplementName: string;
    public EvalCode: string;
    public WornPct: number;
    public Cracks: number;
    public TotalOP: number;
}

export class DashboardFavouriteImplementsCondition {
    public ImplementCondition: DashboardImplementCondition[][][];
    public CracksPresent: boolean;
}

export class EquipmentImplementDetailsRow {
    public EquipmentRow: string[];
    public EquipmentId: number;
    public serialNo:string;
    public unitNo:string;
    public modelDesc:string;
    public siteName:string;
    public currentSMU:string;
    public lastInspectionDate:string;
    public ImplementTypes : GenericIdName[];
    public IsExapand:boolean;

}

export class EquipmentImplementDetails {
    public Details: EquipmentImplementDetailsRow[];
}

export class DashboardFavourites {
    public Id: number;
    public Name: string;
    public DefaultView: number;
    public isDefaultFav:boolean
}


export class ImplementOverviewModel {

    public condition: number

    public customer: string;
    public jobsite: string;
    public make: string;

    public type: string;


    public status: string;

    public equipment_serialno: string;
    public equipment_unitno: string;

    public repairer: string;

    public workshop: string;

    public equipmentId: number;
    public jobsiteId: number;
    public customerId: number;
    public makeId: number;
    public modelId: number;
    public familyId: number;
    public serialNo: string;
    public unitNo: string;
    public modelDesc: string;
    public siteName: string;
    public currentSMU: number;
    public implementId: number;
    public totalRepairCost:number;
    public BCMTototal:number;
    public TonsTotal: number;
    public Life:number;
    public Residual:number;
    public AdditionalSerial:string;
    public ImpBudget:number;
    public RemovelDate:string;
    public warrantyStatus:boolean
    public ResidualHours:number
    public ResidualDays:number
    public hasWarranty:boolean
    public BuildNo:string;
    public TotalLife:number;
    public TotalCount:number;
    public NextInspection:Date;
    public LastInspection:Date;
    public AssetType: string;

}

export class ImplementLocationHistory{
    public Details: ImplementOverviewModel;
    public CycleDetails:ImplementCycleDetails[];
}

export class ReportConfigurationViewModel {

    public Id: number;
    public JobsiteId: number;
    public CustomerId: number;
    public StartDate: Date
    public EndDate: Date
    public ReportSectionId: number;
    public SortOrder: number
    public ReportSectionName: string;
    public IsReportChek: boolean;
    public Jobsite: JobSite;
    public Family: Family;
    public Model: Model;
    public Customer: string;
    public FamilyId:number;
    public ModelId:number;  
    public UnitNumber:string;
    public IsReset:boolean;
    Alertid:number;
    JobsiteIds:string;
    

    ReportConfigurationViewModel(){
       this.Id =0;
       this.JobsiteId =0;
       this.CustomerId =0;
       this.FamilyId=0;
       this.ModelId=0;
       this.StartDate = new Date();
       this.EndDate = new Date();;
       this.ReportSectionId =0;
       this.SortOrder =0;
       this.IsReportChek = false;

    }
}
export interface CrackHistory {
  Family: string;
  Model: string;
  UnitNo: string;
  ComponentTypeName: string;
  ComponentName: string;
  ComponentTypeCount: number;
  ComponentCount: number;
  ObsPointCount: number;
  ShowCrackLength: boolean;
  ShowCracks: boolean;
  ShowRecrack: boolean;
  GETId: number;
  Months: MonthData[];
}
export interface MonthData {
  Month: string;
  TotalCracks: number;
  TotalRecracks: number;
  TotalLength: number;
}
export interface MonthHeader {
  MonthNo: number;
  MonthName: string;
}
export interface CrackHistoryResponse {
  Months: MonthHeader[];
  Data: CrackHistory[];
}